import { render, staticRenderFns } from "./addGoodsSku.vue?vue&type=template&id=cbde37da&scoped=true"
import script from "./addGoodsSku.vue?vue&type=script&lang=js"
export * from "./addGoodsSku.vue?vue&type=script&lang=js"
import style0 from "./addGoodsSku.vue?vue&type=style&index=0&id=cbde37da&lang=scss"
import style1 from "./addGoodsSku.vue?vue&type=style&index=1&id=cbde37da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbde37da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbde37da')) {
      api.createRecord('cbde37da', component.options)
    } else {
      api.reload('cbde37da', component.options)
    }
    module.hot.accept("./addGoodsSku.vue?vue&type=template&id=cbde37da&scoped=true", function () {
      api.rerender('cbde37da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/addGoodsSku.vue"
export default component.exports